import React from 'react';
import { motion } from 'framer-motion';
import { FaHeart, FaStar, FaSmile, FaGem, FaSun, FaMoon } from 'react-icons/fa';

const compliments = [
  { id: 1, text: "Tu as un sourire magnifique 😊", icon: FaSmile, color: "#FFD700" },
  { id: 2, text: "J'adore ton style ✨", icon: FaStar, color: "#FF69B4" },
  { id: 3, text: "Tu es vraiment charmant(e) 💕", icon: FaHeart, color: "#FF1744" },
  { id: 4, text: "Tu as l'air super sympa 🤗", icon: FaSun, color: "#FFA500" },
  { id: 5, text: "Tes photos sont superbes 📸", icon: FaGem, color: "#4A90E2" },
  { id: 6, text: "On dirait que tu as une belle âme 🌙", icon: FaMoon, color: "#9370DB" },
];

const QuickCompliments = ({ onSelect, isVisible }) => {
  if (!isVisible) return null;

  return (
    <motion.div
      className="quick-compliments"
      initial={{ opacity: 0, y: 20, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 20, scale: 0.9 }}
      transition={{ type: "spring", stiffness: 300, damping: 25 }}
    >
      <div className="compliments-header">
        <FaHeart className="compliments-icon" />
        <span>Un compliment rapide ?</span>
      </div>
      <div className="compliments-grid">
        {compliments.map((compliment, index) => (
          <motion.button
            key={compliment.id}
            className="compliment-btn"
            style={{ '--compliment-color': compliment.color }}
            onClick={() => onSelect(compliment.text)}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.05 }}
            whileHover={{ 
              scale: 1.05, 
              boxShadow: `0 4px 15px ${compliment.color}40`
            }}
            whileTap={{ scale: 0.95 }}
          >
            <compliment.icon className="compliment-icon" />
            <span>{compliment.text}</span>
          </motion.button>
        ))}
      </div>
    </motion.div>
  );
};

export default QuickCompliments;
